// CategoryChip.jsx
import React from "react";
import { Chip } from "@mui/material";
import { MdSchedule, MdFlashOn, MdCategory } from "react-icons/md";

const CategoryChip = ({ category }) => {
  if (!category) return null;

  const cat = category.toLowerCase();

  const chipConfig = {
    scheduled: {
      label: "Scheduled",
      icon: <MdSchedule size={18} />,
      bgColor: "#1976d2", // blue
    },
    normal: {
      label: "Immediate",
      icon: <MdFlashOn size={18} />,
      bgColor: "#2e7d32", // green
    },
    default: {
      label: category,
      icon: <MdCategory size={18} />,
      bgColor: "#616161", // grey
    },
  };

  const { label, icon, bgColor } = chipConfig[cat] || chipConfig.default;

  return (
    <Chip
      icon={icon}
      label={label}
      size="small"
      sx={{
        backgroundColor: bgColor,
        color: "white",
        "& .MuiChip-icon": { color: "white" },
        "&:hover": { backgroundColor: "#00000099" }, // subtle hover
      }}
    />
  );
};

export default CategoryChip;
